import { Icon } from '@coop/components';
import { StarFilledIcon, StarIcon } from '@coop/icons';
import classnames from 'classnames';

import A11yTextWrapper from '../../A11yTextWrapper/A11yTextWrapper';
import styles from './RatingStars.module.less';
import { getRatinga11yText } from './RatingStars.utils';

const RatingStars = ({
    size = 'small',
    color = 'dsGreen',
    ...props
}: {
    rating: number;
    votes: number;
    size?: 'small' | 'big';
    color?: React.ComponentProps<typeof Icon>['color'];
}) => {
    const stars = Math.round(props.rating);
    const starIconDimension = size === 'small' ? 12 : 20;

    return (
        <A11yTextWrapper
            a11yText={getRatinga11yText(props.rating, props.votes)}
            a11yType="visuallyHiddenText"
            className={styles.RatingA11y}
        >
            <div className={styles.Rating}>
                <div className={styles.Stars}>
                    {Array.from({ length: 5 }).map((star, index) => (
                        <Icon
                            // eslint-disable-next-line react/no-array-index-key
                            key={index}
                            icon={index < stars ? StarFilledIcon : StarIcon}
                            width={starIconDimension}
                            height={starIconDimension}
                            color={color}
                            aria-hidden
                        />
                    ))}
                </div>
                <div className={classnames(styles.Votes, size === 'big' && styles.Big)} aria-hidden>
                    ({props.votes})
                </div>
            </div>
        </A11yTextWrapper>
    );
};

export default RatingStars;
